const CUENTAS_POR_COBRAR = '12'
const EFECTIVO_Y_EQUIVALENTES = '10'
const CUENTAS_POR_COBRAR_A_ACCIONISTAS = '14'
const CUENTAS_POR_COBRAR_DIVERSAS = '16'
const TRIBUTOS_CONTRAPRESTACIONS_Y_APORTES = '40'
const REMUNERACIONES_Y_PARTICIPACIONES = '41'
const CUENTAS_POR_PAGAR = '42'
const CUENTAS_POR_PAGAR_DIVERSAS = '46'

const __dictionary = {
  [CUENTAS_POR_COBRAR]: {
    id: CUENTAS_POR_COBRAR,
    nombre: '12 - CUENTAS POR COBRAR COMERCIALES – TERCEROS'
  },
  [EFECTIVO_Y_EQUIVALENTES]: {
    id: EFECTIVO_Y_EQUIVALENTES,
    nombre: '10 - EFECTIVO Y EQUIVALENTES DE EFECTIVO'
  },
  [CUENTAS_POR_COBRAR_A_ACCIONISTAS]: {
    id: CUENTAS_POR_COBRAR_A_ACCIONISTAS,
    nombre: '14 - CUENTAS POR COBRAR AL PERSONAL, A LOS ACCIONISTAS (SOCIOS) y'
  },
  [CUENTAS_POR_COBRAR_DIVERSAS]: {
    id: CUENTAS_POR_COBRAR_DIVERSAS,
    nombre: '16 - CUENTAS POR COBRAR DIVERSAS – TERCEROS'
  },
  [TRIBUTOS_CONTRAPRESTACIONS_Y_APORTES]: {
    id: TRIBUTOS_CONTRAPRESTACIONS_Y_APORTES,
    nombre: '40 - TRIBUTOS, CONTRAPRESTACIONES Y APORTES AL SISTEMA PÚBLICO DE PENSIONES'
  },
  [REMUNERACIONES_Y_PARTICIPACIONES]: {
    id: REMUNERACIONES_Y_PARTICIPACIONES,
    nombre: '41 - REMUNERACIONES Y PARTICIPACIONES POR PAGAR'
  },
  [CUENTAS_POR_PAGAR]: {
    id: CUENTAS_POR_PAGAR,
    nombre: '42 - CUENTAS POR PAGAR COMERCIALES TERCEROS'
  },
  [CUENTAS_POR_PAGAR_DIVERSAS]: {
    id: CUENTAS_POR_PAGAR_DIVERSAS,
    nombre: '46 - CUENTAS POR PAGAR DIVERSAS – TERCEROS'
  }
}

const __array = [
  __dictionary[CUENTAS_POR_COBRAR],
  __dictionary[EFECTIVO_Y_EQUIVALENTES],
  __dictionary[CUENTAS_POR_COBRAR_A_ACCIONISTAS],
  __dictionary[CUENTAS_POR_COBRAR_DIVERSAS],
  __dictionary[TRIBUTOS_CONTRAPRESTACIONS_Y_APORTES],
  __dictionary[REMUNERACIONES_Y_PARTICIPACIONES],
  __dictionary[CUENTAS_POR_PAGAR],
  __dictionary[CUENTAS_POR_PAGAR_DIVERSAS]
]

export default Object.freeze({
  CUENTAS_POR_COBRAR,
  EFECTIVO_Y_EQUIVALENTES,
  CUENTAS_POR_COBRAR_A_ACCIONISTAS,
  CUENTAS_POR_COBRAR_DIVERSAS,
  TRIBUTOS_CONTRAPRESTACIONS_Y_APORTES,
  REMUNERACIONES_Y_PARTICIPACIONES,
  CUENTAS_POR_PAGAR,
  CUENTAS_POR_PAGAR_DIVERSAS,
  __dictionary,
  __array
})
